import { Worker } from "@react-pdf-viewer/core";
import { App as AntApp, ConfigProvider } from "antd";
import { Suspense, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AuthGuard from "./components/AuthGuard";
import CustomEmpty from "./components/ui/CustomEmpty";
import Loader from "./components/ui/Loader";
import { PDF_WORKER_URL } from "./constants/global.constants";
import useAppBoot from "./hooks/useAppBoot";
import { publicRouters, sidebarRouters } from "./routers/routers";
import { theme } from "./theme/theme";

export default function App() {
  const [isLoading, setIsLoading] = useState(true);
  const { loading, navigateUrl } = useAppBoot();

  useEffect(() => {
    const t = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(t);
  }, []);

  console.log(process.env.REACT_APP_PORTAL_URL);

  return (
    <Worker workerUrl={PDF_WORKER_URL}>
      <ConfigProvider
        theme={theme}
        renderEmpty={() => <CustomEmpty rootClassName="py-20" />}
      >
        <AntApp>
          {isLoading || loading ? (
            <Loader />
          ) : (
            <Routes>
              <Route path="/" element={<Navigate to={navigateUrl} />} />
              <Route path="/admin" element={<Navigate to={navigateUrl} />} />
              <Route
                path="/dashboard"
                element={<Navigate to={navigateUrl} />}
              />

              {/* Public routers */}
              {publicRouters.map(({ path, element: Element }, idx) => (
                <Route
                  path={path}
                  key={idx + path}
                  element={
                    <Suspense fallback={<Loader />}>
                      <Element />
                    </Suspense>
                  }
                />
              ))}

              {/* sidebar routers */}
              {sidebarRouters.map(({ path, element: Element, roles }, idx) => (
                <Route
                  path={path}
                  key={path + idx}
                  element={
                    <AuthGuard roles={roles}>
                      <Suspense fallback={<Loader />}>
                        <Element />
                      </Suspense>
                    </AuthGuard>
                  }
                />
              ))}
            </Routes>
          )}
        </AntApp>
      </ConfigProvider>
    </Worker>
  );
}
